import React from "react";
import { Helpers } from "../Helpers";
import Icon from "../MysticIcon";

export default function ExcursionItem({ tour, currency, product_url }) {
  // console.log("tour", tour);

  const addOns = tour.tags.data.filter(tag => tag.tag_group_name == 'Add Ons').map(tag => tag.name);
  const activities = tour.tags.data.filter(tag => tag.tag_group_name == 'Tour Activities');
  // console.log("activities", activities);

  return (
    <div
      className="row bg-white mx-auto border-primary excursion-item"
      style={{
        borderRadius: "20px",
        borderWidth: "2px",
        borderStyle: "solid",
        overflow: "hidden",
        minHeight: "430px",
      }}
    >
      <div className="col col-12 col-md-5 p-0">
        <img
          src={tour.cover_photo.medium}
          style={{ height: "100%", width: "100%", objectFit: "cover", minHeight: "200px" }}
        />
      </div>
      <div className="col col-12 col-md-7 p-4">
        <h4 className="font-weight-bold text-uppercase" >{tour.name}</h4>
        <p
          className="small line-clamp line-clamp-3"
          dangerouslySetInnerHTML={{ __html: tour.overview }}
        ></p>

        {activities.length > 0 && 
          <div className="mb-3">
            <p className="text-uppercase font-weight-bold">Activities:</p>
            <div className="small activity-list text-center">
              {activities.map((activity, i) => (
                <span key={i} className="activity mr-2 mb-2">
                  {activity.slug && 
                    <Icon name={activity.slug} />
                  }
                  <div className="text-uppercase font-weight-bold small mt-1">{activity.name}</div>
                </span>
              ))}
            </div>
          </div>
        }

        {addOns.length > 0 &&
          <div className="mb-3">
            <p className="text-uppercase font-weight-bold mb-1">Add-ons:</p>
            <div className="small add-ons-list">
              {addOns.map((addOn, i) => (
                <span key={i} className="mr-2 mb-1 font-weight-bold text-uppercase add-on">{ addOn }</span>
              ))}
            </div>
          </div>
        }

        <div
          className="btn mr-3 mb-2"
          style={{
            color: "#2b5534",
            borderRadius: "15px",
            backgroundColor: "#d4ef91",
          }}
        >
          <div className="d-flex">
            <span
              className="font-weight-bold mr-1 mb-1"
              style={{ fontSize: "18px" }}
            >
              { Helpers.formatNoDecimalCurrency(tour.price)}
            </span>
            <div className="small text-left">
              <p style={{ marginBottom: "-5px" }}>{ currency }D</p>
              <p className="m-0 small">per person</p>
            </div>
          </div>
        </div>

        <a
          href={product_url}
          className="text-uppercase btn btn-primary  px-3 py-2"
          style={{ borderRadius: "15px" }}
        >
          <span className="small font-weight-bold">Learn more</span>
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/ExcursionItem/index.js